import NavbarSite from "../navbars/NavbarSite";
import SidebarSite from "../sidebars/SidebarSite";
import ModalCreateMission from "../modal/dataModal/data/modalMission/ModalCreateMission";
import UseContext from "../../hooks/useContext";

const PageContainer = ({
  children,
  type,
  dateStart,
  setDateStart,
  dateEnd,
  setDateEnd,
  /** default: padding uniforme. hourly_tracking / activity: pas de py global — la page gère la ligne filtres (pt-3 pb-4 px-20) comme le suivi horaire. mission: pas de padding — la page définit bandeau intérimaire puis zone mission. */
  contentLayout = "default",
}) => {
  const {
    showCreateMission,
    setShowCreateMission,
    companySelected,
    setRefreshMissions,
  } = UseContext();

  /** Suivi horaire / activité : scroll interne (table), pas scroll sur cette zone principale */
  const mainUsesInnerScrollOnly =
    contentLayout === "hourly_tracking" || contentLayout === "activity";

  const mainClass = [
    "flex min-h-0 flex-1 flex-col",
    mainUsesInnerScrollOnly ? "overflow-hidden" : "overflow-y-auto",
  ].join(" ");

  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <div className={"flex h-full min-h-0"}>
        <SidebarSite />
        <div className={"flex min-h-0 flex-1 flex-col"}>
          <NavbarSite
            type={type}
            dateStart={dateStart}
            setDateStart={setDateStart}
            dateEnd={dateEnd}
            setDateEnd={setDateEnd}
          />
          <div className={mainClass}>{children}</div>
        </div>
      </div>
      <ModalCreateMission
        isOpen={showCreateMission}
        companyId={companySelected?.idCompany}
        onClose={() => setShowCreateMission(false)}
        onSaved={() => {
          setShowCreateMission(false);
          setRefreshMissions((value) => !value);
        }}
      />
    </div>
  );
};

export default PageContainer;
